import { render, staticRenderFns } from "./LgsPrintGuidePdf.vue?vue&type=template&id=45eb60c2"
import script from "./LgsPrintGuidePdf.vue?vue&type=script&lang=js"
export * from "./LgsPrintGuidePdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports